import {FieldProps, wdiCore, WdiInput, WdiModalAppProps} from '@/components/WdiControls';
import {HorzLayoutOpts, WdiModalForm} from '@/components/WdiControls/WdiModalForm';
import {ResponseStatus} from '@/utils/request';
import {Form, Input, message} from 'antd';
import React, {useEffect, useRef, useState} from 'react';
import {ProFormInstance} from '@ant-design/pro-form';
import {WdiInputNumber} from '@/components/WdiControls/WdiInputNumber';
import {WdiSelect, WdiSelectFormat, WdiTreeSelect} from '@/components/WdiControls/WdiSelect';
import {Product} from '@/services/mdm/product';
import {ECMKT} from '@/services/mdm/ecmkt';
import {Enum} from '@/enums/system';
import {FormSaMkt} from '@/services/mkt/sa';
import {Company} from '@/services/mdm/company';


const FormSaMktDetailEditApp: React.FC<WdiModalAppProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  const [expandKeysProduct, setExpandKeysProduct] = useState<string[]>();
  const {row, rowIndex, rows} = props.data;

  useEffect(() => {
    if (row) {
      Product.searchAll({productIds: row.productId, isActive: true}).then(response => {
        if (response && response.data) {
          setExpandKeysProduct(response.data.map(item => `${item.productId}`));
          formRef.current?.setFieldsValue({
            productId: response.data.map(item => ({
              value: item.productId,
              label: item.codeOrName,
            })),
          });
        }
      });
      formRef.current?.setFieldsValue({
        ecMktId: {value: row.ecMktId, label: row.ecMktName},
        amount: row.amount,
        remark: row.remark,
        companyCode: {value: row.companyCode, label: wdiCore.String.CodeOrName(row.companyCode, row.companyName)},
      });
    }

  }, []);

  return (
    <>
      <WdiModalForm
        formRef={formRef}
        initialValues={{paymentMethodId: Enum.PaymentMethod.THIRD_PART, paymentMethodName: '第三方付款(给供应商/员工)'}}
        {...HorzLayoutOpts}
        title={props.title}
        visible={props.visible}
        modalProps={{
          onCancel: () => {
            props.onClose?.();
          },
        }}
        onFinish={async (values) => {
          const {productId, ecMktId,companyCode, ...entity} = values;
          entity.productId = WdiSelectFormat.getvalue(productId);
          entity.ecMktId = WdiSelectFormat.getvalue(ecMktId);
          entity.companyCode = WdiSelectFormat.getvalue(companyCode);

          const response = await FormSaMkt.Buttons.validateDetail({
            rowIndex: rowIndex,
            formSaMktDetail: entity,
            formSaMktDetails: rows,
          });
          if (response.code !== ResponseStatus.SUCCESS) {
            message.error(response.message);
          } else {
            response.data = Object.assign({}, {rowIndex: rowIndex}, response.data);
            props.onSave?.(response);
          }
        }}
      >
        <Form.Item name='companyCode' label='公司' rules={[{required: true, message: '公司不能为空'}]}>
          <WdiSelect
            {...{
              placeholder: '请选择公司',
              showSearch: true,
              dataLoading: async (params) => {
                const response = await Company.search(Object.assign({}, params));
                return response.data.map((item) => {
                  return {
                    value: item.companyCode,
                    label: wdiCore.String.CodeOrName(item.companyCode, item.companyName)
                  };
                });
              },
            }} />
        </Form.Item>
        <Form.Item name='productId' label='产品别' rules={[{required: true, message: '产品别不能为空！'}]}>
          <WdiTreeSelect {...{
            placeholder: '请选择产品别',
            labelInValue: true,
            defaultExpandKeys: expandKeysProduct,
            dataLoading: async (params) => {
              const response = await Product.searchAll(
                Object.assign({
                  productLevels: [Enum.ProductLevel.PRODUCT1,Enum.ProductLevel.PRODUCT2, Enum.ProductLevel.PRODUCT3].join(),
                  isActive: true,
                  withPermissions:true
                }, params),
              );
              const {treeData, dict} = FieldProps.TreeSelect.formatTreeData({
                textField: 'codeOrName',
                valueField: 'productId',
                id: 'productId',
                pId: 'parentId',
                level: 'productLevel',
              }, response.data);
              return {treeData, dict};
            },
            onExSelect: (value: any, node: any, dict: any) => {
              const values = formRef.current?.getFieldValue('productBuyIds');
              const rtv = FieldProps.TreeSelect.labeledValuesMeger(dict, values, {value});
              formRef.current?.setFieldsValue({
                productBuyIds: rtv,
              });
            },
          }} />
        </Form.Item>
        <Form.Item name='ecMktId' label='费用项' rules={[{required: true, message: '费用项不能为空！'}]}>
          <WdiTreeSelect
            {...{
              placeholder: '请选择费用项',
              labelInValue: true,
              dataLoading: async () => {
                const responseResult = await ECMKT.search({
                  isActive: true,
                  ecLevels: [Enum.ECLevel.EC2, Enum.ECLevel.EC3].join(),
                });
                const {treeData, dict} = FieldProps.TreeSelect.formatTreeData({
                  textField: 'ecMktName',
                  valueField: 'ecMktId',
                  id: 'ecMktId',
                  pId: 'parentId',
                  level: 'ecLevel',
                  disabledLevel: [Enum.ECLevel.EC2],
                }, responseResult.data);
                return {treeData, dict};
              },
            }}
          />
        </Form.Item>

        <Form.Item name='amount' label='申请金额' rules={[{required: true, message: '申请金额不能为空！'}]}>
          <WdiInputNumber format='d' digits={2} min={0} placeholder={'请填写申请金额'}/>
        </Form.Item>
        <Form.Item name='remark' label='备注'>
          <Input.TextArea style={{resize: 'both'}} maxLength={2000}/>
        </Form.Item>
        <Form.Item name='paymentMethodId' label='支付方式' hidden>
          <WdiInput readOnly/>
        </Form.Item>
        <Form.Item name='paymentMethodName' label='支付方式' rules={[{required: true, message: '支付方式不能为空！'}]}>
          <WdiInput readOnly/>
        </Form.Item>

      </WdiModalForm>
    </>
  );
};
export default FormSaMktDetailEditApp;
